import PropTypes from "prop-types";

export const getEIMFromMSC = (inputEIM) => {
    return inputEIM;
}

export const getFinancialTypeProductEIM = (fieldValueEIM, selectedVehicleType, productsForCustomer, customer) => {
    const objectModified = {...fieldValueEIM};
    objectModified["financialProducts"] = [];
    for (const key in objectModified) {
        if (key.indexOf("_rate_id") >= 0) {
            const newKey = key.split("_rate_id")[0].split(customer)[1];
            const productType = newKey?.split(customer)[0].split("_")[1];
            if(productType !== undefined) {
                const objToInject = {
                    'vehicleType': selectedVehicleType,
                    'productTypeCode': productType,
                    'rateID': objectModified[key],
                    'defaultFinancialProduct': objectModified[customer + `_defaultRentalProduct`] === productType
                }
                delete objectModified[key];
                if(productsForCustomer) {
                    productsForCustomer.includes(productType) && objectModified['financialProducts'].push(objToInject);
                }
                else{
                    objectModified['financialProducts'].push(objToInject);
                }
            }
        }
    }
    delete objectModified.defaultFinancialProduct;

    return objectModified;
}

export const getFinancialProductConfigurationByProductSelected = (appData, customer, productTypeCode, rateID) => {
    return appData.rates[customer+"_"+productTypeCode].find(c => c.rateId === rateID);
}

export const financialProductConfigurationPropTypesShape = {
    vehicleType: PropTypes.string,
}